module.exports = __webpack_public_path__ + "img/ic_service_item_img1.4500b2f6.png";